<template>
  <a :href="href"
    class="nav-link"
    :class="{
      'has-icon': hasIcon,
      'nav-link-secondary': isSecondary
    }"
  >
    <i v-if="hasIcon"
      class="nav-link-icon"
      :class="iconClasses"
      aria-hidden="true"
      role="img"
    />
    <slot />
  </a>
</template>

<script>
export default {
  name: 'NavMenuLink',
  props: {
    href: {
      type: String,
      default: '',
      required: true
    },
    hasIcon: {
      type: Boolean,
      default: false
    },
    iconClasses: {
      type: Array,
      default: []
    },
    isSecondary: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/color-theme';

  .nav-link {
    position: relative;
    display: flex;
    padding: .5rem 1rem;
    font-weight: 700;

    &.has-icon {
      padding-left: 4rem;
      align-items: center;
      gap: 1.125rem;

      ~ .nav-link:not(.has-icon) {
        padding-left: 4rem;
      }
    }

    &:hover,
    &:focus,
    &:active {
      background-color: $light-blue;
      color: $blue;
    }

    &-secondary {
      font-weight: 400;
    }

    &-icon {
      position: absolute;
      top: 50%;
      left: 0;
      font-size: 1.25rem;
      color: $blue;
      transform: translate(1.5rem, -50%);
    }
  }
</style>
